/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ModMedResultMessage = {
    readonly id?: number;
    status?: ModMedResultMessage.status;
    /**
     * Optional reason for error status
     */
    error_reason?: string | null;
    readonly created_at?: string;
}

export namespace ModMedResultMessage {

    export enum status {
        PENDING = 'pending',
        SUCCESS = 'success',
        ERROR = 'error',
        HOLD = 'hold',
        DROPPED = 'dropped',
    }


}
